import { Directive, h, render } from "vue"

const skeleton: Directive = (el, binding) => {
    const mask = h('div', {
        class: 'skeleton top-0 left-0 right-0 bottom-0 absolute z-10000'
    });
    el.classList.add('relative');
    render(binding.value ? mask : null, el);
}

export default skeleton;